import * as React from 'react';
import Chip from '@mui/material/Chip';
import Rating from '@mui/material/Rating';
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import FavoriteIcon from '@mui/icons-material/Favorite';

import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { trimSentence } from '../../../utils';

const StyleChip = styled(Chip)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#fff' : 'rgba(255,255,255, 0.8)',
  padding: theme.spacing(0),
  textAlign: 'center',
  fontSize: '1.1rem',
  fontWeight: 'bold',
  color: '#000',

}));

export default function RecipeReviewCard({ listing }) {
  return (
    <Card sx={{ maxWidth: 345, borderRadius: 3, cursor: 'pointer' }}>
      <div style={{ position: "relative" }}>
        <CardMedia
          component="img"
          height="184"
          image={listing.images?.[0] || ''}
          alt={listing.name}
        />
        <div style={{ position: 'absolute', top: 5, left: 5, display: 'flex', justifyContent: 'space-between', width: '100%' }}>
          <StyleChip label={listing.name} />
        </div>
      </div>

      <CardContent sx={{ padding: '0px 12px' }}>
        <Box component='div' sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Rating name="read-only" value={4} readOnly size="medium" />
          <IconButton aria-label="add to favorites">
            <FavoriteIcon />
          </IconButton>
        </Box>
        <Typography variant="body1" color="text.secondary">
          {trimSentence(listing.description, 6)}...
        </Typography>
      </CardContent>
    </Card>
  );
}
